import { Col, Row, TabPane, Button } from 'reactstrap';
import { BiHappyBeaming } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const FinishedDocument = () => {
  return (
    <TabPane tabId="10">
      <Row>
        <Col className="text-center">
          <h2 className="text-primary">Está tudo OK!</h2>
          <BiHappyBeaming size={150} className="text-success" />
          <p style={{ fontWeight: 'bold' }}>
            Entraremos em contato se for necessário análisar mais algum
            documento.
          </p>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center align-items-center">
        <Link to="/">
          <Button size="sm" color="secondary">
            Voltar ao Sistema
          </Button>
        </Link>
      </Row>
    </TabPane>
  );
};

export default FinishedDocument;
